import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MANIFESTO, fadeUp } from "./content";

export default function Manifesto() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="approach"
      ref={ref}
      className="relative overflow-hidden bg-forest text-bone grain py-24 md:py-36"
      data-testid="manifesto-section"
    >
      <motion.img
        src="https://images.unsplash.com/photo-1576085898384-b3cdb88736e9"
        alt=""
        aria-hidden
        style={{ y: bgY }}
        className="absolute inset-0 h-[116%] w-full object-cover opacity-[0.10]"
      />
      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fadeUp}
          className="max-w-3xl mb-20"
        >
          <span className="overline text-sage">The approach</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.03]">
            A locum that feels like part of your team.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 rounded-[8px] overflow-hidden border border-white/10">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              variants={fadeUp}
              custom={i}
              className="bg-forest p-10 md:p-12"
              data-testid={`manifesto-${m.no}`}
            >
              <span className="font-display text-6xl md:text-7xl text-sage/40 leading-none">
                {m.no}
              </span>
              <h3 className="mt-8 font-display text-2xl md:text-[1.7rem] tracking-tight">
                {m.title}
              </h3>
              <p className="mt-4 text-sage/90 leading-relaxed">{m.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
